export const mainNav = [
  {label: 'Home', to: '/'},
  {label: 'About', to: '/aboutme'}, 
  {label: 'Books', to: '/books'},
  {label: 'Contact', to: '/contact'},
];

export const moreNav = [
  {label: 'News', to: '/news'},
  {label: 'Events', to: '/events'},
  {label: 'Newsletter', to: '/newsletter'},
  {label: 'Writing Tips', to: '/writingtips'},
  {label: 'Reviews', to: '/reviews'},
];
